/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Components
import { Icon } from 'components/atoms/Icon/';

// Utils
import { camelCaseToLowerCaseUnderscore } from 'utils/string';
import { clickEvent } from 'utils/adaConfigurations/customEvents';

import './InputField.scss';

const ns = 'input-field';

class InputField extends Component {
  constructor(props) {
    super(props);
    this.clearInput = this.clearInput.bind(this);
  }

  clearInput() {
    this.input.value = '';
  }

  generateInputGroup = () => {
    const {
      placeholder,
      leftAddonConf,
      rightAddonConf,
      type,
      inputConf
    } = this.props;
    const leftAddon = leftAddonConf
      ? leftAddonConf.isGlyhicon
        ? this.generateAddonGlyhicon(leftAddonConf)
        : this.generateAddonText(leftAddonConf)
      : '';
    const rightAddon = rightAddonConf
      ? rightAddonConf.isGlyhicon
        ? this.generateAddonGlyhicon(rightAddonConf)
        : this.generateAddonText(rightAddonConf)
      : '';

    return [
      leftAddon,
      this.generateInput(type, placeholder, inputConf),
      rightAddon
    ];
  };

  generateInput = (type, placeholder, inputConf) => {
    const { inputAriaLabel } = this.props;
    const inputConfName = inputConf.name
      ? camelCaseToLowerCaseUnderscore(inputConf.name)
      : null;
    return (
      <input
        onInput={e => this.onInputField(e)}
        className={`${ns}__input ${inputConf.name}_input`}
        {...inputConfName && { id: `${inputConfName}_input` }}
        type={type}
        placeholder={placeholder}
        key="input"
        ref={element => (this.input = element)}
        {...inputConf}
        tabIndex={0}
        aria-label={inputAriaLabel || ''}
      />
    );
  };

  onInputField = e => {
    const { maskReg } = this.props;
    if (maskReg) {
      this.input.value = e.target.value.replace(maskReg, '');
    }
  };

  generateAddonGlyhicon = ({
    addonValue,
    onAddonClick = () => {},
    iconClassName
  }) => {
    const { iconAriaLabel, iconAriaHidden, iconTabIndex = -1 } = this.props;
    const iconType = {
      back: 'arrow__back',
      'back-close': 'arrow__back',
      clear: 'close'
    };
    let onClick;
    const iconClassProps = classNames(iconClassName, `${ns}__icon`);
    switch (addonValue) {
      case 'clear':
        onClick = this.clearInput;
        break;
      default:
        onClick = onAddonClick;
    }
    return (
      <Icon
        type={iconType[addonValue] || addonValue}
        key={addonValue}
        className={iconClassProps}
        onClick={onClick}
        aria-label={iconAriaLabel}
        aria-hidden={iconAriaHidden}
        tabIndex={iconTabIndex}
        onKeyUp={clickEvent}
      />
    );
  };

  generateAddonText = value => {
    return (
      <span className={`${ns}__addon`} key="addonText">
        {value}
      </span>
    );
  };

  render() {
    const { labelText, className } = this.props;
    const classProps = classNames(ns, className);
    const classInputGroup = classNames(`${ns}__group`, 'input-group');
    return (
      <div className={classProps}>
        {labelText && <label className={`${ns}__label`}>{labelText}</label>}
        <div className={classInputGroup}>{this.generateInputGroup()}</div>
      </div>
    );
  }
}

InputField.propTypes = {
  addonConf: PropTypes.object,
  className: PropTypes.string,
  inputConf: PropTypes.object,
  labelText: PropTypes.string,
  leftAddonConf: PropTypes.object,
  maskReg: PropTypes.object,
  placeholder: PropTypes.string,
  rightAddonConf: PropTypes.object,
  type: PropTypes.string.isRequired,
  iconAriaLabel: PropTypes.string,
  inputAriaLabel: PropTypes.string,
  iconAriaHidden: PropTypes.bool
};

InputField.defaultProps = {
  maskReg: null,
  iconAriaLabel: ''
};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/atoms/InputField/InputField.js